<template>
  <transition name="temp">
    <div class="template-box" ref="tBox" v-show="boxShow">
      <div class="main">
        <div
          class="temp-item"
          v-for="(item,index) in list"
          :key="index"
          @click="handleClick(item,index)"
        >
          <div class="container" v-if="!index">
            <img src="../assets/add_icon.png" alt />
            <p class="empty-title">空白问卷</p>
          </div>
          <div v-else class="container">
            <div class="template-icon">
              <img src="../assets/template.png" alt />
              <span>模板</span>
            </div>
            <img class="dot-icon" src="../assets/dot.png" alt />
            <p class="title" style="-webkit-box-orient: vertical">{{removeLables(item.remarkName || item.title)}}</p>
            <p class="subtitle">{{item.referenceCount}}次引用</p>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
import http from "../utils/http";
import { MSG, removeLables } from "../utils/utils.js";
var throttle = function(fn, delay) {
  var timer = null;
  return function() {
    var context = this,
      args = arguments;
    clearTimeout(timer);
    timer = setTimeout(function() {
      fn.apply(context, args);
    }, delay);
  };
};
export default {
  name: "templateBox",
  data() {
    return {
      list: [{}],
      interface: {
        getTemplateList: `/template/user/list`
      }
    };
  },
  props: ["boxShow"],
  watch: {
    boxShow: {
      handler(val) {
        if (val) {
          this.getTemplateList();
        } else {
        }
      }
    }
  },
  created() {
    window.onresize = throttle(this.updatePage, 30);
  },
  mounted() {
    // this.updatePage()
  },
  methods: {
    updatePage() {
      if (this.$refs.tBox) {
        if (
          this.list &&
          this.list.length * 200 + 100 < document.body.clientWidth
        ) {
          this.$refs.tBox.classList = "template-box single-height";
        } else {
          this.$refs.tBox.classList = "template-box";
        }
        this.updateList();
      }
    },
    updateList() {
      this.$el.querySelectorAll(".temp-item").forEach(e => {
        if (e.getBoundingClientRect().top > 400) {
          e.style.visibility = "hidden";
        } else {
          e.style.visibility = "visible";
        }
      });
    },
    removeLables(html) {
      return removeLables(html);
    },
    getTemplateList() {
      http.get(this.interface.getTemplateList).then(response => {
        const { code, data, message } = response;
        if (code === 1) {
          this.list = [{}, ...data];
          this.$nextTick(() => {
            this.updateList();
          });
        } else {
          MSG.error(message);
        }
      });
    },
    handleClick(item, index) {
      if (index == 0) {
        this.$router.push({
          path: "/home/edit"
        });
      } else {
        this.$emit("preview", `${item.url}&type=template&source=pcPreview`);
      }
    }
  }
};
</script>


<style lang="scss" scoped>
.template-box {
  height: 352px;
  background: #f5f5f5;
  &.single-height {
    height: 196px;
  }
  .main {
    padding: 30px 50px 10px;
    height: 100%;
    display: flex;
    flex-wrap: wrap;
    .temp-item {
      background-color: #fff;
      width: 180px;
      height: 136px;
      margin-bottom: 20px;
      margin-right: 20px;
      position: relative;
      cursor: pointer;
      border-radius: 5px;
      &:hover {
        transform: scale(1.05);
        box-shadow: 0 1px 10px 0 rgba(0, 0, 0, 0.1);
      }
      &:nth-child(1) .container {
        text-align: center;
        img {
          position: relative;
          top: 61px;
        }
        p {
          display: inline-block;
          font-family: PingFangSC-Regular;
          font-size: 16px;
          color: #ff6200;
          letter-spacing: 0;
          line-height: 20px;
          height: 20px;
          position: relative;
          top: 56px;
          left: 2px;
        }
      }
      .template-icon {
        display: inline-block;
        text-align: center;
        position: relative;
        left: 20px;
        img {
          width: 32px;
          height: 20px;
        }
        span {
          font-family: PingFangSC-Regular;
          font-size: 12px;
          color: #fff;
          letter-spacing: 0;
          line-height: 20px;
          height: 20px;
          position: relative;
          left: -34px;
          top: -6px;
        }
      }
      .dot-icon {
        position: absolute;
        top: 30px;
        width: 22px;
        height: 17px;
        left: 20px;
      }
      .title {
        font-family: PingFangSC-Regular;
        font-size: 16px;
        color: #333333;
        letter-spacing: 0;
        line-height: 24px;
        position: absolute;
        top: 38px;
        left: 20px;
        width: calc(100% - 30px);
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
      }
      .subtitle {
        font-family: PingFangSC-Regular;
        font-size: 12px;
        color: #999999;
        letter-spacing: 0;
        line-height: 15px;
        position: absolute;
        bottom: 20px;
        left: 20px;
      }
    }
  }
}
.temp-enter-active,
.temp-leave-active {
  transition: all 1s;
}
.temp-enter,
.temp-leave-to {
  height: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/templateBox.vue